import { apiClient } from '@/plugins/axios'; // Import your axios instance


const getOrganizations = async (filters: Record<string, any> = {}) => {
  const params = new URLSearchParams(filters as any);
  return apiClient.get('/organizations?' + params.toString()); // Let the error bubble up
};

const getOrganizationById = async (id: number) => {
  return await apiClient.get(`/organizations/${id}`); // Fetch car listing by ID
};

const createOrganization = async (organizationData: any) => {
  return await apiClient.post('/organizations', organizationData); // Create a new car listing
};

const updateOrganization = async (id: number, organizationData: any) => {
  return await apiClient.patch(`/organizations/${id}`, organizationData); // Update car listing by ID
};

const deleteOrganization = async (id: number) => {
  return await apiClient.delete(`/organizations/${id}`); // Delete car listing by ID
};

const getSuggestedPrice = async (filters: string) => {
  return apiClient.get('/organization_prices?' + filters);
};

export default {
  getOrganizations,
  getOrganizationById,
  createOrganization,
  updateOrganization,
  deleteOrganization,
  getSuggestedPrice
};
